import {
  ref,
  onUnmounted,
  watch,
  Ref,
} from 'vue'
import { message } from 'ant-design-vue'
import {
  DRC_METHOD,
  DroneControlProtocol,
} from '/@/types/drc'
import {
  useMqtt,
  DeviceTopicInfo
} from './use-mqtt'
import { controlKeyApi } from '/@/api/drone-control/drone'
import ConnectWebSocket, { MessageHandler } from '/@/websocket'
import { getWebsocketUrl } from '/@/websocket/util/config'
import { CURRENT_CONFIG } from '/@/api/http/config'
import { useMyStore } from "/@/store";
const store = useMyStore();
let myInterval: any
let timer = null as any //延时器，用于调用键盘手动控制 节流
export enum KeyCode {
  KEY_W = 'KeyW',
  KEY_A = 'KeyA',
  KEY_S = 'KeyS',
  KEY_D = 'KeyD',
  KEY_Q = 'KeyQ',
  KEY_E = 'KeyE',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
}

export function useManualControl (deviceTopicInfo: DeviceTopicInfo, isCurrentFlightController: Ref<boolean>) {
  const activeCodeKey = ref(null) as Ref<KeyCode | null>
  const mqttHooks = useMqtt(deviceTopicInfo)

  // 节流 在一定时间范围内，只会执行一次方法 fn回调函数、delay时间
  function throttle (fn:any, delay = 300) {
      if(timer == null){
          timer = setTimeout(() => {
              fn()
              clearTimeout(timer)
              timer = null
          }, delay);
      }
  }
  // 调用手动控制接口
  async function setOrderDock(key:string,sn:any, flag:boolean) {
    // console.log(51111,flag);
    
    // // 是否可以进行下一次手控操作，true为可以进行手控操作，false不可以
    // if (flag==true) {
    //   await controlKeyApi(key,sn)
    //   // 成功后将mqttFlag值变为false
    //   store?.commit('SET_MQTT_FLAG', false)
    // }
  }
  // 通过 mqtt向机场发送指令
  function handlePublish (params: DroneControlProtocol) {
    // debugger
    // console.log('handleKeyup--3555',params);
    const body = {
      method: DRC_METHOD.DRONE_CONTROL,
      data: params,
    }
    // console.log('handleKeyup--body',body);
    
    handleClearInterval()
    console.log('handleKeyup--body',body);
    
    myInterval = setInterval(() => {
      // debugger
      console.log('handleKeyup--keyCode>>>>', activeCodeKey.value, body)
      body.data.seq = new Date().getTime()
      // 参数1  pubTopic 后端返回，参数2  body: method:'drone_control、data:{y:-5,seq:时间戳} 参数3 {qos: 0}
      mqttHooks?.publishMqtt(deviceTopicInfo.pubTopic, body, { qos: 0 })

    }, 50)
  }

  function handleKeyup (keyCode: KeyCode,sn:string,flag:boolean) {
    // console.log('handleKeyup-4888',deviceTopicInfo);
    // drc链路放在后端，不用判断pubtopic是否存在，传值传按键和机场的sn
    // if (!deviceTopicInfo.pubTopic) {
    //   // message.error('请确保已经建立DRC链路')
    //   return
    // }
    // return
    if (!sn) {
      return
    }
    console.log('handleKeyup-5444',keyCode,activeCodeKey.value,sn);
    // debugger
    const SPEED = 5 //  前进后退速度
    const HEIGHT = 5 //  上升下降
    const W_SPEED = 20 // 机头角速度
    switch (keyCode) {
      case 'KeyA':
        // if (activeCodeKey.value === keyCode) return
        // handlePublish({ y: -SPEED })
        // 在500毫秒内只会调用一次 手动控制 接口
        // throttle(setOrderDock('a',sn),500)
        setOrderDock('a',sn,flag)
        activeCodeKey.value = keyCode
        break
      case 'KeyW':
        // if (activeCodeKey.value === keyCode) return
        // handlePublish({ x: SPEED })
        // 在500毫秒内只会调用一次 手动控制 接口
        // throttle(setOrderDock('w',sn),500)
        setOrderDock('w',sn,flag)
        activeCodeKey.value = keyCode
        break
      case 'KeyS':
        // if (activeCodeKey.value === keyCode) return
        // handlePublish({ x: -SPEED })
        // 在500毫秒内只会调用一次 手动控制 接口
        // throttle(setOrderDock('s',sn),500)
        setOrderDock('s',sn,flag)
        activeCodeKey.value = keyCode
        break
      case 'KeyD':
        // if (activeCodeKey.value === keyCode) return
        // handlePublish({ y: SPEED })
        // 在500毫秒内只会调用一次 手动控制 接口
        // throttle(setOrderDock('d',sn),500)
        setOrderDock('d',sn,flag)
        activeCodeKey.value = keyCode
        break
      case 'ArrowUp':
        // if (activeCodeKey.value === keyCode) return
        // handlePublish({ h: HEIGHT })
        // 在500毫秒内只会调用一次 手动控制 接口
        // throttle(setOrderDock('up',sn),500)
        setOrderDock('up',sn,flag)
        activeCodeKey.value = keyCode
        break
      case 'ArrowDown':
        // if (activeCodeKey.value === keyCode) return
        // handlePublish({ h: -HEIGHT })
        // 在500毫秒内只会调用一次 手动控制 接口
        // throttle(setOrderDock('down',sn),500)
        setOrderDock('down',sn,flag)
        activeCodeKey.value = keyCode
        break
      case 'KeyQ':
        // if (activeCodeKey.value === keyCode) return
        // handlePublish({ w: -W_SPEED })
        // 在500毫秒内只会调用一次 手动控制 接口
        // throttle(setOrderDock('q',sn),500)
        setOrderDock('q',sn,flag)
        activeCodeKey.value = keyCode
        break
      case 'KeyE':
        // if (activeCodeKey.value === keyCode) return
        // handlePublish({ w: W_SPEED })
        // 在500毫秒内只会调用一次 手动控制 接口
        // throttle(setOrderDock('e',sn),500)
        setOrderDock('e',sn,flag)
        activeCodeKey.value = keyCode
        break
      default:
        break
    }
  }

  function handleClearInterval () {
    // console.log('handleKeyup--清除定时器',myInterval);
    
    clearInterval(myInterval)
    // console.log('handleKeyup--清除定时器结束');
    
    myInterval = undefined
    // console.log('handleKeyup--清除11111');
  }

  function resetControlState () {
    activeCodeKey.value = null
    handleClearInterval()
  }

  function onKeyup () {
    resetControlState()
  }

  function onKeydown (e: KeyboardEvent) {
    handleKeyup(e.code as KeyCode,'',false)
  }

  function startKeyboardManualControl () {
    window.addEventListener('keydown', onKeydown)
    window.addEventListener('keyup', onKeyup)
  }

  function closeKeyboardManualControl () {
    resetControlState()
    window.removeEventListener('keydown', onKeydown)
    window.removeEventListener('keyup', onKeyup)
  }

  watch(() => isCurrentFlightController.value, (val) => {    
    if (val && deviceTopicInfo.pubTopic) {
      startKeyboardManualControl()
    } else {
      closeKeyboardManualControl()
    }
  }, { immediate: true })

  onUnmounted(() => {
    closeKeyboardManualControl()
  })

  function handleEmergencyStop () {
    if (!deviceTopicInfo.pubTopic) {
      message.error('请确保已经建立DRC链路')
      return
    }
    const body = {
      method: DRC_METHOD.DRONE_EMERGENCY_STOP,
      data: {}
    }
    resetControlState()
    window.console.log('handleEmergencyStop>>>>', deviceTopicInfo.pubTopic, body)
    mqttHooks?.publishMqtt(deviceTopicInfo.pubTopic, body, { qos: 1 })
  }

  return {
    activeCodeKey,
    handleKeyup,
    handleEmergencyStop,
    resetControlState,
  }
}
